export default __webpack_public_path__ + "static/media/priorTool.97447ddc.svg";